import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useRestartDeploymentGroup } from '@/queries/deploymentGroupQueries'
import { DeploymentStatus } from '@/types/deployment'
import { DeploymentGroup } from '@/types/deploymentGroup'
import { GroupCameraList } from './GroupCameraList'
import { GroupConfirmModal } from './GroupConfirmModal'
import { getGroupCameraNames } from './deploymentTreeHelpers'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type GroupRestartConfirmProps = {
  opened: boolean
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
  onClose: () => void
}

export const GroupRestartConfirm = ({
  opened,
  group,
  context,
  onClose
}: GroupRestartConfirmProps) => {
  const { mutateAsync: restartGroup, isPending } = useRestartDeploymentGroup()
  const run = useRunDeploymentAction(onClose)

  const names = getGroupCameraNames(group, context.device)

  const handleConfirm = () =>
    void run(() => restartGroup(group.id), {
      inProgress: 'deployments.groups.actions.restart.inProgress',
      error: 'deployments.groups.actions.restart.error'
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={<FormattedMessage id="deployments.groups.actions.restart.title" />}
      confirmLabel={
        <FormattedMessage id="deployments.groups.actions.restart.title" />
      }
      isPending={isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id={
            group.status === DeploymentStatus.Stopped
              ? 'deployments.groups.actions.restart.confirmation.stopped'
              : 'deployments.groups.actions.restart.confirmation'
          }
          values={{
            number: context.label,
            device: context.deviceName,
            count: names.length
          }}
        />
      </Text>

      <GroupCameraList names={names} />

      <Text size="sm" c="dimmed">
        <FormattedMessage id="deployments.groups.actions.restart.engineReused" />
      </Text>
    </GroupConfirmModal>
  )
}
